import React, { useState } from "react";
import { AppBar, Box, Button, IconButton, TextField, Toolbar, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";

const DescriptionInput = ({ value, onChange }) => {
    const [description, setDescription] = useState(value || "");
    const navigate = useNavigate();

    const handleSave = () => {
        if (onChange) onChange(description);
        navigate(-1); // Возвращаемся назад
    };

    const handleBack = () => {
        navigate(-1); // Переход на предыдущую страницу
    };

    return (
        <Box sx={{ display: "flex", flexDirection: "column", height: "100vh" }}>
            {/* Верхняя панель с кнопкой "Назад" */}
            <AppBar position="static" color="default">
                <Toolbar>
                    <IconButton edge="start" color="inherit" onClick={handleBack} aria-label="Назад">
                        <ArrowBackIcon />
                    </IconButton>
                    <Typography variant="h6" sx={{ flexGrow: 1 }}>
                        Введите описание
                    </Typography>
                </Toolbar>
            </AppBar>

            {/* Основное содержимое */}
            <Box sx={{ flex: 1, px: 2, pt: 2 }}>
                <TextField
                    fullWidth
                    multiline
                    rows={6}
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    placeholder="Введите описание..."
                    variant="outlined"
                />
                <Button variant="contained" color="primary" sx={{ mt: 2 }} onClick={handleSave}>
                    ОК
                </Button>
            </Box>
        </Box>
    );
};

export default DescriptionInput;
